var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEyeClosed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3C3C43",
  strokeLinecap: "round",
  strokeOpacity: 0.6,
  strokeWidth: 1.25,
  d: "M5 19 19 5m0 4.257a14 14 0 0 1 1.489 1.884 1.55 1.55 0 0 1 .001 1.716C19.402 14.515 16.572 18 12 18c-.546 0-1.067-.05-1.562-.14M13.65 6.157A8.7 8.7 0 0 0 12 6c-4.573 0-7.403 3.485-8.49 5.143a1.55 1.55 0 0 0 0 1.716c.342.52.853 1.217 1.535 1.93"
})));
export default SvgEyeClosed;